import PropTypes from "prop-types";
import React from "react";
import {
    StyledMainMenu,
    StyledMegamenu,
    StyledMegaTitle,
    StyledNavbar,
    StyledNavItem,
    StyledNavLink,
    StyledSubmenu,
} from "./style";

const MainMenu = ({
    menuData,
    color,
    space,
    vSpace,
    bottomLine,
    alignment,
    ...props
}) => {
    return (
        <StyledMainMenu $alignment={alignment} {...props}>
            <StyledNavbar>
                {menuData?.map((menu) => {
                    const submenu = menu.submenu ? menu.submenu : null;
                    const megaMenu = menu.megamenu ? menu.megamenu : null;
                    return (
                        <StyledNavItem
                            className="nav-item"
                            key={`mainmenu-${menu.id}`}
                            hasSubmenu={submenu}
                            hasMegamenu={megaMenu}
                            $space={space}
                            $alignment={alignment}
                        >
                            <StyledNavLink
                                className="nav-link"
                                path={menu.link}
                                hassubmenu={
                                    submenu || megaMenu ? "true" : "false"
                                }
                                $color={color}
                                $vSpace={vSpace}
                                $bottomLine={bottomLine}
                            >
                                <span>{menu.text}</span>
                                {(submenu || megaMenu) && (
                                    <i className="icon fa fa-angle-down"></i>
                                )}
                            </StyledNavLink>
                            {submenu && (
                                <StyledSubmenu className="submenu">
                                    {submenu.map((subitem, i) => {
                                        const hasSubmenuLevelTwo =
                                            subitem.isSubmenu;
                                        const submenuLevelTwo = subitem.submenu;
                                        return (
                                            <StyledNavItem
                                                className="nav-item"
                                                key={`submenu-${menu.id}-${i}`}
                                                $subitem
                                            >
                                                <StyledNavLink
                                                    className="nav-link"
                                                    path={subitem.link}
                                                    $bottomLine={bottomLine}
                                                    $sublink
                                                >
                                                    <span>{subitem.text}</span>
                                                    {hasSubmenuLevelTwo && (
                                                        <i className="icon fa fa-angle-down"></i>
                                                    )}
                                                </StyledNavLink>
                                                {submenuLevelTwo && (
                                                    <StyledSubmenu>
                                                        {submenuLevelTwo.map(
                                                            (
                                                                subitemLevelTwo,
                                                                j
                                                            ) => {
                                                                return (
                                                                    <StyledNavItem
                                                                        key={`submenu-${menu.id}-${i}-${j}`}
                                                                        $subitem
                                                                    >
                                                                        <StyledNavLink
                                                                            path={
                                                                                subitemLevelTwo.link
                                                                            }
                                                                            $sublink
                                                                            $bottomLine={
                                                                                bottomLine
                                                                            }
                                                                        >
                                                                            {
                                                                                subitemLevelTwo.text
                                                                            }
                                                                        </StyledNavLink>
                                                                    </StyledNavItem>
                                                                );
                                                            }
                                                        )}
                                                    </StyledSubmenu>
                                                )}
                                            </StyledNavItem>
                                        );
                                    })}
                                </StyledSubmenu>
                            )}
                            {megaMenu && (
                                <StyledMegamenu className="megamenu">
                                    {megaMenu.map((megaitem, i) => {
                                        const megaSubmenu = megaitem.submenu;
                                        return (
                                            <li
                                                key={`megamenu-${menu.id}-${i}`}
                                            >
                                                <StyledMegaTitle>
                                                    {megaitem.title}
                                                </StyledMegaTitle>
                                                {megaSubmenu && (
                                                    <ul>
                                                        {megaSubmenu.map(
                                                            (
                                                                megaSubitem,
                                                                j
                                                            ) => {
                                                                return (
                                                                    <StyledNavItem
                                                                        key={`megasubmenu-${i}-${j}`}
                                                                        $megitem
                                                                    >
                                                                        <StyledNavLink
                                                                            path={
                                                                                megaSubitem.link
                                                                            }
                                                                            $bottomLine={
                                                                                bottomLine
                                                                            }
                                                                            $sublink
                                                                        >
                                                                            <span>
                                                                                {
                                                                                    megaSubitem.text
                                                                                }
                                                                            </span>
                                                                        </StyledNavLink>
                                                                    </StyledNavItem>
                                                                );
                                                            }
                                                        )}
                                                    </ul>
                                                )}
                                            </li>
                                        );
                                    })}
                                </StyledMegamenu>
                            )}
                        </StyledNavItem>
                    );
                })}
            </StyledNavbar>
        </StyledMainMenu>
    );
};

MainMenu.propTypes = {
    alignment: PropTypes.oneOf(["left", "center", "right"]),
    menuData: PropTypes.arrayOf(PropTypes.shape({})),
    color: PropTypes.oneOf(["light", "white", "dark"]),
    space: PropTypes.oneOf([1, 2]),
    vSpace: PropTypes.oneOf([1, 2]),
    bottomLine: PropTypes.bool,
};

MainMenu.defaultProps = {
    alignment: "center",
    color: "dark",
    space: 1,
    vSpace: 1,
    bottomLine: true,
};

export default MainMenu;
